import Parse from "parse";

export interface ArticleAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  artnr: string;
  name: string;
  targettime: number;
}

export class Article extends Parse.Object<ArticleAttributes> {
  static className: string = "OD3_MES_Article";

  constructor(data?: Partial<ArticleAttributes>) {
    super("OD3_MES_Article", data as ArticleAttributes);
  }

  get artnr(): string {
    return super.get("artnr");
  }
  set artnr(value: string) {
    super.set("artnr", value);
  }
  get name(): string {
    return super.get("name");
  }
  set name(value: string) {
    super.set("name", value);
  }
  get targettime(): number {
    return super.get("targettime");
  }
  set targettime(value: number) {
    super.set("targettime", value);
  }
}

Parse.Object.registerSubclass("OD3_MES_Article", Article);
